import { Injectable } from "@angular/core";
import { Vinculo } from "@tivic-team/manager-ts/dist/grl/entities/vinculo.entity";
import { HttpGet, JSONData, Quark, Url, HttpResponse, HttpPost, HttpPut } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";

@Injectable()
export class VinculoController {

    constructor() {}

    async get( cdVinculo:number ):Promise< Vinculo > {
        let quark = new Quark(
            new HttpGet( {
                url: new Url( {
                    id: 'grl/vinculo/:cdVinculo',
                    environment: environment,
                    pathParams: new JSONData( { cdVinculo: cdVinculo } )
                }),
            }),
            new HttpResponse(
                new Vinculo()
            )
        );
        return await quark.call()
    }

    async find( filtros?:IFilter ):Promise< Array< Vinculo > > {
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/vinculo',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array< Vinculo >()
			)
		);
		return await quark.call();
    }

    async create( vinculo: Vinculo ):Promise< Vinculo > {
        let quark= new Quark( 
            new HttpPost( {
                url: new Url( {
                    id: 'grl/vinculo',
                    environment: environment
                }),
                data: new JSONData( vinculo )
            }),
            new HttpResponse( 
                new Vinculo()
            )
        );
        return await quark.call();
    }

    async update( vinculo: Vinculo ):Promise< Vinculo > {
        let quark = new Quark(
            new HttpPut( {
                url: new Url( {
                    id: 'grl/vinculo/:cdVinculo',
                    environment: environment,
                    pathParams: new JSONData( { cdVinculo: vinculo.cdVinculo } )
                }),
                data: new JSONData( vinculo )
            }),
            new HttpResponse(
                new Vinculo()
            )
        )
        return await quark.call();
    }
}